const fr = {
  onf: {
    activity: {
      category: {
        label: 'Autre',
        label_sportEvent: 'Manifestation sportive',
        label_schoolOuting: 'Sortie scolaire',
        label_noSportingOtherEvent: 'Autres sorties non sportives',
        label_shooting: 'Tournage ou prise de vues',
      },
    },
  },
  error: {
    unspecific: 'Une erreur est survenue. Veuillez réessayer plus tard.',
    authentication: 'Impossible de se connecter avec les informations d\'identification fournies.',
    password: 'Mot de passe incorrect',
    empty_password: 'Veuillez saisir un mot de passe',
    username: 'Identifiant incorrect',
    email: 'Email incorrect',
    empty_email: 'Veuillez saisir une adresse email',
    404: 'Page non trouvée.',
    401: 'Vous devez être connecté pour accéder à cette ressource.',
    500: 'Une erreur est survenue. Veuillez réessayer ou revenir plus tard.',
  },
  profileTranslations: {
    Nom: 'Nom',
    'Numéro SIRET (facultatif)': 'Numéro SIRET (facultatif)',
    Adresse: 'Adresse',
    'Code postal': 'Code postal',
    Ville: 'Ville',
    'Personne(s) de contact': 'Personne(s) de contact',
    Enregistrer: 'Enregistrer',
    'Nom et type de structure': 'Nom et type de structure',
    'Le nom est obligatoire': 'Le nom est obligatoire',
    'Le type de structure est obligatoire': 'Le type de structure est obligatoire',
    'L\'adresse est obligatoire': 'L\'adresse est obligatoire',
    'Le code postal est obligatoire': 'Le code postal est obligatoire',
    'La ville est obligatoire': 'La ville est obligatoire',
    'Affiliations et partenariats': 'Affiliations et partenariats',
    'Votre structure est-elle rattachée à une ou plusieurs fédérations ?': 'Votre structure est-elle rattachée à une ou plusieurs fédérations ?',
    "Disposez-vous d'un label qualité ou d'une convention de partenariat avec l'ONF ?": "Disposez-vous d'un label qualité ou d'une convention de partenariat avec l'ONF ?",
    'Nom du label': 'Nom du label',
    'Supprimer ce contact': 'Supprimer ce contact',
    'Ajouter une personne de contact': 'Ajouter une personne de contact',
    'Adresse de la structure': 'Adresse de la structure',
  },
  profileContactTranslations: {
    Prénom: 'Prénom',
    'Ce champ est obligatoire': 'Ce champ est obligatoire',
    Nom: 'Nom',
    'Fonction dans la structure': 'Fonction dans la structure',
    'Code postal': 'Code postal',
    Ville: 'Ville',
    Téléphone: 'Téléphone',
    'Téléphone secondaire': 'Téléphone secondaire',
  },
  headerTranslations: {
    leave_draft_confirm: 'Vous n\'avez pas enregistré votre formulaire comme brouillon. Si vous retournez en arrière, vous perdrez toutes les informations saisies. Etes-vous sûr(e) de vouloir quitter ce formulaire sans sauvegarder ?',
    Yes: 'Oui',
    No: 'Non',
  },
  PricesForm: {
    royalties: 'Montant de la redevance',
    fees: 'Frais de dossier',
    dailyPrice: 'Tarif journalier',
    daysCount: 'Nombre de jours',
    searchFees: 'Recherche de site (forfait)',
    exceptionalCost: 'Surcoûts "Dépôt de matériel exceptionnel"',
    makingCost: 'Participation à la fabrication',
    rightToImage: 'Droits à l\'image',
    misc: 'Divers (annexe 8)',
  },
  Features: {
    Polygon: 'Zone',
    Point: 'Point',
    LineString: 'Tronçon',
  },
};

export default fr;



// WEBPACK FOOTER //
// ./src/locales/fr.js